import React from "react";

import { VideoGridBlock } from "@reactivated";

import { Clickable } from "../Clickables";

import breakpoints from "../../styles/breakpoint.module.scss";
import styles from "./video-grid.module.scss";

export const YoutubeThumbnail = ({ videoId }: { videoId: string }) => (
    <img
        src={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`}
        srcSet={`https://img.youtube.com/vi/${videoId}/maxresdefault.jpg 1280w,
                https://img.youtube.com/vi/${videoId}/hqdefault.jpg 480w,
                https://img.youtube.com/vi/${videoId}/mqdefault.jpg 320w,
                https://img.youtube.com/vi/${videoId}/default.jpg 120w`}
        sizes={`(max-width: ${breakpoints.mobile}) 50vw,
                (max-width: ${breakpoints.tablet}) 33vw,
                25vw`}
        role="presentation"
        alt=""
    />
);

export const VideoGrid = ({ value }: { value: VideoGridBlock }) => (
    <>
        <p className={styles.count}>{value.grid_items?.length ?? 0} videos</p>
        <ul className={styles.videos}>
            {value.grid_items?.map((video, i) => (
                <li key={i}>
                    <Clickable href={video.url} className={styles.card}>
                        <YoutubeThumbnail videoId={video.embed_id} />
                        {video.tag && <p className={styles.tag}>{video.tag}</p>}
                        <span className={styles.title}>{video.title}</span>
                    </Clickable>
                </li>
            ))}
        </ul>
    </>
);
